import * as THREE from "three";

function createSphere({ color }: { color: THREE.ColorRepresentation }): THREE.Mesh {
  const geometry = new THREE.SphereGeometry(1, 32, 32);
  const material = new THREE.MeshBasicMaterial({ color });
  const mesh = new THREE.Mesh(geometry, material);

  return mesh;
}

export { createSphere };
